export const INTERNATIONAL_PHONE_REGEX = /^\+[1-9]\d{9,14}$/;
export function isValidInternationalPhone(phone: string): boolean {
    return INTERNATIONAL_PHONE_REGEX.test(phone);
}

export function normalizePhone(phone: string): string | null {
    if (!phone) return null;
    // Strip whitespace and common formatting separators
    let normalized = phone.replace(/[\s\t\-().]/g, "");
    if (normalized.startsWith("00")) {
        normalized = "+" + normalized.slice(2);
    }

    return isValidInternationalPhone(normalized) ? normalized : null;
}
